import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectDestructuringEmpty from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getDirectionConfig, getIp } from "@/routes/api/resources";
import getPageTitle, { arrayFind } from "@/commons/utils/functions";
import { isEmpty } from '@/commons/utils/functions';
import mime from "mime-types";
import i18n from '@/lang/lang_config';
import { getDirection, setDirecction, getLang, setLang } from "@/commons/utils/auth"; //import settings from '@/settings/settings'

import router from "@/routes/app/routes";
var state = {
  location: {
    'country_code': ''
  },
  address: getDirection(),
  lang: getLang(),
  header: {
    title: '',
    sub_title: ''
  }
};
var mutations = {
  SET_LOCATION: function SET_LOCATION(state, location) {
    state.location = location;
  },
  SET_HEADER: function SET_HEADER(state, head) {
    state.header = head;
  },
  SET_DIRECTION: function SET_DIRECTION(state, direction) {
    state.address = direction;
  },
  SET_LANG: function SET_LANG(state, lang) {
    state.lag = lang;
  }
};
var actions = {
  setHeader: function setHeader(_ref, head) {
    var commit = _ref.commit;
    commit('SET_HEADER', head);
    document.title = getPageTitle(i18n.tc(head.title));
  },
  getLocation: function getLocation(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit;
              getIp().then(function (response) {
                commit('SET_LOCATION', response.data);
              }).catch(function () {
                console.info('not loacation avaible');
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getDirection: function getDirection(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              getDirectionConfig().then(function (response) {
                commit('SET_DIRECTION', response.data);
                setDirecction(response.data);
              }).catch(function () {
                console.info('not direcction avaible');
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  // eslint-disable-next-line no-empty-pattern
  getCountryFrom: function getCountryFrom(_ref4, countries) {
    _objectDestructuringEmpty(_ref4);

    return arrayFind(countries, function (elem) {
      return elem.iso.toString().toLowerCase() === state.location.country_code.toString().toLowerCase();
    });
  },
  // eslint-disable-next-line no-unused-vars
  setMessage: function setMessage(_ref5, message) {
    var _message;

    var dispatch = _ref5.dispatch;
    var h = this._vm.$createElement;
    message = (_message = message) !== null && _message !== void 0 ? _message : i18n.tc('connexion_error');
    return this._vm.$message({
      showClose: true,
      message: h('p', {
        style: 'margin-right:20px'
      }, [h('div', {}, message)]),
      duration: 40000
    });
  },
  setLocale: function setLocale(_ref6, command) {
    var commit = _ref6.commit;
    i18n.locale = command;
    commit('SET_LANG', command);
    setLang(command);
    var locale = i18n.locale === 'uy' ? 'es' : i18n.locale;
    if (command == 'bnf') locale = 'bnf';

    this._vm.$moment.locale(locale);
  },
  catchErrors: function catchErrors(_ref7, _ref8) {
    var dispatch = _ref7.dispatch;
    var _this = _ref8._this,
        error = _ref8.error;

    if (!isEmpty(error.response) && error.response.data.errors !== undefined) {
      if (!error.response.data.errors.general === true) {
        _this.errors.record(error.response.data.errors);

        if (!!error.response.data.errors.captcha === true) {
          dispatch('setMessage', error.response.data.errors.captcha, {
            root: false
          });
        }
      } else {
        dispatch('setMessage', error.response.data.errors.general, {
          root: false
        });
      }
    } else {
      dispatch('setMessage', _this.$t('connexion_error'), {
        root: false
      });
    }

    if (process.env !== 'production') {
      console.warn('[PZ Warn][Caught Error]: ' + error);
    }

    console.log('error catc');
  },
  // eslint-disable-next-line no-unused-vars
  googleTagManger: function googleTagManger(_ref9, name) {
    var commit = _ref9.commit;

    if (isEmpty(name)) {
      name = name ? router.currentRoute.meta.title : router.currentRoute.fullPath;
    }

    this._vm.$gtm.push({
      event: name
    });
  },
  // eslint-disable-next-line no-unused-vars
  getFileTypeExtencions: function getFileTypeExtencions(_ref10, fileType) {
    var commit = _ref10.commit;
    return mime.extension(fileType);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};